export const getFeatureRequestDescriptionPreview = (description, maxLength = 200) => {
  const text = description || '';
  if (text.length <= maxLength) return text;

  const preview = text.slice(0, maxLength);
  const lastSpace = preview.lastIndexOf(' ');
  return `${preview.slice(0, lastSpace > -1 ? lastSpace : maxLength).trimEnd()}...`;
};

export const getFeatureRequestCommentAttachmentUrl = (comment) => {
  if (!comment || typeof comment !== 'object') return '';

  const attachmentUrlKeys = [
    'commentAttachment', 'attachmentUrl', 'attachmentURL', 'attachment_url', 'fileUrl', 'fileURL',
    'file_url', 'downloadUrl', 'downloadURL', 'download_url', 'attachmentPath',
    'attachment_path', 'filePath', 'file_path', 'attachment', 'file', 'url'
  ];

  for (const key of attachmentUrlKeys) {
    const value = comment[key];
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (value && typeof value === 'object') {
      const nestedUrl = value.url || value.downloadUrl || value.downloadURL || value.path;
      if (typeof nestedUrl === 'string' && nestedUrl.trim()) return nestedUrl.trim();
    }
  }

  for (const [key, value] of Object.entries(comment)) {
    if (/(attachment|file).*(url|path|link)/i.test(key) && typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  return '';
};

export const hasFeatureRequestCommentAttachment = (comment) => {
  if (getFeatureRequestCommentAttachmentUrl(comment)) return true;
  return Boolean(comment?.isAttachment || comment?.hasAttachment || comment?.attachmentName || comment?.fileName);
};

export const resolveFeatureRequestCommentAttachmentUrl = (url, apiBaseUrl) => {
  if (!url || /^(https?:|data:|blob:)/i.test(url)) return url || '';
  return `${apiBaseUrl}/${url.replace(/^\//, '')}`;
};